/** @module csi/widget/_svg/ShapeAlignTop */
define([
	"./_ShapeAlign",
	"./PluginFactory"
], function(_ShapeAlign,PluginFactory) {

	return PluginFactory.declare(_ShapeAlign, {
		/**
		 * @property {String} iconClass - CSS class to be applied.
		 */
		iconClass: "csiActionIcon svgIconAlignTop",		

		/**
		 * @property {String} pluginName - Plugin name to be used for adding to toolbar.
		 */
		pluginName: "shapeAlignTop",

		/**
		 * @property {String} title - Title for the plugin icon.
		 */
		title: "CanvasShapeAlignTop",

		/**
		 * @property {String} shapeAlignOption - Shape align option: Top.
		 */
		shapeAlignOption: "top"
	});
});
